import { selectFromAll, selectFromCurrentCELs } from './dictionary'

export const selectConventionalPMI = selectFromCurrentCELs(
  'conventionalPmiMonthlyTotal'
)
export const selectEstimatedPMI = selectFromCurrentCELs(
  'estimatedPmiMonthlyTotal'
)
export const selectLTVPercent = selectFromCurrentCELs('ltvPercent')
export const showPMIContainer = selectFromAll('showPmiSection')

// returns the dates at which loan to original value would hit a certain point (only calculated for 78% and 80%)
// returns {78: <Date>, 80: <Date>}
export const selectLoanToOriginalValueAutomaticPmiRemovalDates = state =>
  state?.home?.data?.metadata?.ltvAutomatedDates
